module.exports = __webpack_public_path__ + "static/media/event1.af402d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/event1.jpg
// module id = 241
// module chunks = 0